import { Link } from 'react-router-dom';
import type { Category } from '../../types/models';
import { CategoryIcon } from './CategoryIcon';

interface CategoryTileProps {
  category: Category;
  label: string;
}

export function CategoryTile({ category, label }: CategoryTileProps) {
  return (
    <Link
      to={`/?category=${category}`}
      className="card flex flex-col items-center justify-center gap-3 text-center py-6 hover:border-lime-500 hover:text-lime-400 transition-colors"
    >
      <span className="w-11 h-11 rounded-full bg-surface-700 flex items-center justify-center">
        <CategoryIcon category={category} />
      </span>
      <span className="text-sm font-medium">{label}</span>
    </Link>
  );
}
